// Render the Job product information and optionally the currently loaded quantity
import clsx from 'clsx';

import {
  getJobProductName,
  getJobTotalQuantities,
} from '@isd/lib/firebase/db/helpers';
import { JobDoc } from '@isd/lib/firebase/db/metaTypes';

export default function JobProductLabel({ jobDoc }: { jobDoc: JobDoc }) {
  const jobProductStr = getJobProductName(jobDoc);
  if (!jobProductStr) return null;

  const unit = jobDoc.get('unit');
  const { tons } = getJobTotalQuantities(jobDoc);
  const totalQuantity = tons > 0 ? tons.toFixed(2) : 0;
  const showJobTotalQty = unit === 'tons';
  // Check if job has total requested quantity filled
  const productQuantity = jobDoc.get('productQuantity');
  const showRequestedQuantity = !!productQuantity;

  const jobQtyStr = showRequestedQuantity
    ? `${totalQuantity}/${productQuantity} ${unit}`
    : `${totalQuantity} ${unit}`;
  return (
    <div
      className={clsx(
        'job-product-label flex text-xs',
        showJobTotalQty ? 'justify-between' : 'justify-start'
      )}
    >
      <div className="product-name">{jobProductStr}</div>
      {showJobTotalQty && (
        <div className="total-quantity-label">{jobQtyStr}</div>
      )}
    </div>
  );
}
